import React from 'react';
import { useLocation } from 'react-router-dom';
import { ENV, SITE_URL } from '../../../config/index.js';

const Sidebar = ({ handleViewChange, sidebarOpen, mobileSidebarOpen }) => {
  const location = useLocation();
  const path = location.pathname;

  return (
    <div
      className={
        mobileSidebarOpen
          ? 'fuselight-v5-sidebar mobile-sidebar-open'
          : 'fuselight-v5-sidebar'
      }
    >
      <div
        className={
          sidebarOpen && mobileSidebarOpen
            ? 'button-container sidebar-open mobile-sidebar-open'
            : sidebarOpen
            ? 'button-container sidebar-open'
            : mobileSidebarOpen
            ? 'button-container mobile-sidebar-open'
            : 'button-container'
        }
      >
        <button
          className="create-new btn btn--secondary-outline"
          onClick={() => handleViewChange('launchpad')}
        >
          <div className="plus"></div>
          <span>Create New</span>
        </button>
        <hr />
        <button
          className={
            path === '/launchplans' ? 'icon-button current-view' : 'icon-button'
          }
          onClick={() => handleViewChange('launchplans')}
          {...(path === '/launchpad' && {
            'data-tooltip':
              'A collection of ideas and potential fusions for a specific goal. Think of it as a project.'
          })}
        >
          <div className="icon-circle outline">
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/icons/launchplan-icon.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/icons/launchplan-icon.svg`
              }
              alt="Launchplan Icon"
              className="launchplan-icon"
              width={32}
            />
          </div>
          <div className="icon-circle filled">
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/icons/launchplan-icon-filled.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/icons/launchplan-icon-filled.svg`
              }
              alt="Launchplan Icon"
              className="launchplan-icon"
              width={32}
            />
          </div>
          {path === '/launchplans' ? (
            <span style={{ fontWeight: '700', color: '#fff' }}>
              Launchplans
            </span>
          ) : (
            <span>Launchplans</span>
          )}
        </button>

        <button
          className={
            path === '/fusions' ? 'icon-button current-view' : 'icon-button'
          }
          onClick={() => handleViewChange('fusions')}
          {...(path === '/launchpad' && {
            'data-tooltip':
              'This is a collaboration between a brand and a promoter, with a specific idea in mind.'
          })}
        >
          <div className="icon-circle outline">
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/icons/fusions-icon.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/icons/fusions-icon.svg`
              }
              alt="Fusions Icon"
              className="fusions-icon"
              width={32}
            />
          </div>
          <div className="icon-circle filled">
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/icons/fusions-icon-filled.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/icons/fusions-icon-filled.svg`
              }
              alt="Fusions Icon"
              className="fusions-icon"
              width={32}
            />
          </div>
          {path === '/fusions' ? (
            <span style={{ fontWeight: '700', color: '#fff' }}>Fusions</span>
          ) : (
            <span>Fusions</span>
          )}
        </button>

        <button
          className={
            path === '/pitches' ? 'icon-button current-view' : 'icon-button'
          }
          onClick={() => handleViewChange('pitches')}
          {...(path === '/launchpad' && {
            'data-tooltip':
              'A pitch deck compiling your brand fusions to help you go from ideating to pitching in minutes.'
          })}
        >
          <div className="icon-circle outline">
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/icons/pitches-icon.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/icons/pitches-icon.svg`
              }
              alt="Pitches Icon"
              className="pitches-icon"
              width={32}
            />
          </div>
          <div className="icon-circle filled">
            <img
              src={
                ENV === 'development'
                  ? `${SITE_URL}/app/themes/hahn/images/icons/pitches-icon-filled.svg`
                  : `${SITE_URL}/wp-content/themes/hahn/images/icons/pitches-icon-filled.svg`
              }
              alt="Pitches Icon"
              className="pitches-icon"
              width={32}
            />
          </div>
          {path === '/pitches' ? (
            <span style={{ fontWeight: '700', color: '#fff' }}>Pitches</span>
          ) : (
            <span>Pitches</span>
          )}
        </button>

        <a href="/fusions-in-the-news/" className="nav-simple">
          <span>Fusion News</span>
          <span
            style={{
              position: 'relative',
              left: '100px',
              width: '40px',
              border: '1px solid #00edff',
              fontSize: '10px',
              color: '#00edff',
              padding: '2px 5px',
              borderRadius: '12px',
              textAlign: 'center'
            }}
          >
            NEW
          </span>
        </a>

        <button
          className="nav-simple margin-top"
          onClick={() => handleViewChange('about')}
        >
          <span>About</span>
        </button>
        <a href="/pricing/" target="_blank" className="nav-simple">
          <span>Subscribe</span>
        </a>
        <a href="/support-ticket/" target="_blank" className="nav-simple">
          <span>
            Support<sup>Beta</sup>
          </span>
        </a>
        <button
          className="nav-simple"
          onClick={() => handleViewChange('tutorial')}
        >
          <span>How it works</span>
        </button>
      </div>
    </div>
  );
};

export default Sidebar;
